import toast from 'react-hot-toast';
import Icon from "@material-tailwind/react/Icon";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { checkUser } from "helpers/Session";
import API from "../helpers/api";
const Kegiatan = () => {
	const [allKegiatan, setAllKegiatan] = useState([]);
	const [kegiatan, setKegiatan] = useState("");
	const [tanggal, setTanggal] = useState("");
	const [dummy, setDummy] = useState([]);
	const [kementerian, setKementerian] = useState(0);
	const [id, setId] = useState(0);
	const [allKementerian, setAllKementerian] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadKegiatan, setLoadKegiatan] = useState(true);
	const [valid, setValid] = useState(false);
	const [showAddModal, setShowAddModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [message, setMessage] = useState("");

	const addKegiatan = async () => {
		if (loading) return;
		setLoading(true);
		try {
			const response = await API.post("/kegiatan", {
				id_kementerian: kementerian,
				kegiatan: kegiatan,
				tanggal: tanggal === "" ? null : tanggal,
			});
			if (response.status === 200) {
				toast.success("Data berhasil ditambahkan");
				setLoadKegiatan(true);
				setShowAddModal(false);
			} else {
				toast.error("Data gagal ditambahkan");
			}
		} catch (error) {
			
		} finally {
			setLoading(false);
		}
	};

	const editKegiatan = async () => {
		if (loading) return;
		setLoading(true);
		try {
			const response = await API.put(`/kegiatan/${id}`, {
				id_kementerian: kementerian,
				kegiatan: kegiatan,
				tanggal: tanggal === "" ? null : tanggal,
			});
			if (response.status === 200) {
				toast.success("Data berhasil diubah");
				setLoadKegiatan(true);
				setShowEditModal(false);
			} else {
				toast.error("Data gagal diubah");
			}
		} catch (error) {
			
		} finally {
			setLoading(false);
		}
	};

	const deleteKegiatan = (id) => {
		Swal.fire({
			title: "Apakah kamu yakin?",
			text: "Kamu akan menghapus data tersebut?",
			icon: "warning",
			showCancelButton: true,
			showLoaderOnConfirm: true,
			preConfirm: () => {
				return API.delete(`/kegiatan/${id}`)
					.then((response) => {
						if (response.status === 200) {
							return response.data;
						} else {
							throw new Error(response.data);
						}
					})
					.catch((error) => {
						toast.error("Data gagal dihapus");
						throw error; // Propagate the error further
					});
			},
			allowOutsideClick: () => !Swal.isLoading(),
		})
			.then((res) => {
				if (res.isConfirmed) {
					toast.success("Data berhasil dihapus");
					setLoadKegiatan(true);
				}
			})
			.catch((error) => {
				Swal.fire("Error", "Terjadi kesalahan: " + error.message, "error");
			});
	};

	const resetForm = () => {
		setKementerian(0);
		setId(0);
		setValid(false);
		setKegiatan("");
		setTanggal("");
		setMessage("");
	};

	const closeModal = () => {
		setShowAddModal(false);
		setShowEditModal(false);
		resetForm();
	};

	useEffect(() => {
		let pass = true;

		if (kegiatan === "" || Number(kementerian) === 0) {
			pass = false;
		}

		if (pass) {
			setValid(true);
			setMessage("✅ Periksa kembali sebelum submit!");
		} else {
			setValid(false);
			setMessage("❌ Periksa format pengisian!");
		}
	}, [kegiatan, kementerian]);

	useEffect(() => {
		if (!showAddModal && !showEditModal) {
			resetForm();
		}
	}, [showAddModal, showEditModal]);

	useEffect(() => {
		if (!loadKegiatan) return;
		(async () => {
			await API.get("/kegiatan")
				.then((res) => {
					const kegiatanData = Array.isArray(res.data.data) ? res.data.data : [];
					setAllKegiatan(kegiatanData);
					setDummy(kegiatanData);
				})
				.catch((err) => {
					Swal.fire({
						icon: "error",
						title: "Terjadi kesalahan",
						text: "Silahkan hubungi PIT!",
						footer: "Error: " + err.message,
					});
				})
				.finally(() => {
					setLoadKegiatan(false);
				});
		})();
	}, [loadKegiatan]);

	useEffect(() => {
		const fetchData = async () => {
			await API.get("/kementerian")
				.then((res) => {
					setAllKementerian(Array.isArray(res.data.data) ? res.data.data : []);
				})
				.catch((err) => {
					Swal.fire({
						icon: "error",
						title: "Terjadi kesalahan",
						text: "Silahkan hubungi PIT!",
						footer: "Error: " + err.message,
					});
				});
		};

		fetchData();
	}, []);

	const setDataUpdate = (item) => {
		setKegiatan(item.kegiatan || "");
		setId(item.id_kegiatan);
		setKementerian(item.id_kementerian || 0);
		setTanggal(item.tanggal || "");
		setShowEditModal(true);
	};

	const search = (params) => {
		if (params === "") {
			setAllKegiatan(dummy);
		} else {
			let result = dummy.filter(
				(item) =>
					(item.kegiatan || "").toLowerCase().includes(params.toLowerCase()) ||
					(item.kementerian?.singkatan || "")
						.toLowerCase()
						.includes(params.toLowerCase())
			);
			setAllKegiatan(result);
		}
	};

	return (
		<>
			{!checkUser() ? (
				<Redirect to={"/"} />
			) : (
				<>
					<div className="bg-primary-light px-3 md:px-8 h-40" />

					<div className="px-3 md:px-8 h-auto -mt-36">
						<div className="container mx-auto max-w-full min-h-screen">
							<div className="grid grid-cols-1 px-4 mb-16">
								<div className="flex w-full justify-between my-4">
									<div className="self-center">
										<button className="bg-success text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-success/90 transition shadow-sm"
											onClick={(e) => setShowAddModal(true)}
										>
											<Icon name="add" size="xl" /> Tambah Kegiatan
										</button>
									</div>
									<div className="self-center">
										<div className="pt-2 relative mx-auto text-text-body">
											<input
												className="bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none"
												type="text"
												name="search"
												placeholder="Cari Sesuatu..."
												onChange={(e) => search(e.target.value)}
											/>
											<button
												type="submit"
												className="absolute right-0 top-0 mt-5 mr-4"
												disabled
											>
												<Icon name="search" size="xl" />
											</button>
										</div>
									</div>
								</div>
								<div className="glass-card flex flex-col min-w-0 break-words bg-white w-full shadow-soft rounded-2xl">
									<div className="p-6">
										<div className="overflow-x-auto overflow-y-auto max-h-screen">
											<table className="relative items-center w-full border-collapse">
												<thead>
													<tr>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															No
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															Kegiatan
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															Tanggal
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-left">
															Kementerian
														</th>
														<th className="sticky top-0 bg-white px-2 text-primary align-middle border-b border-solid border-gray-200 py-3 text-sm whitespace-nowrap font-semibold text-center">
															Aksi
														</th>
													</tr>
												</thead>
												<tbody>
													{!loadKegiatan ? (
														allKegiatan.length > 0 ? allKegiatan.map((item, index) => {
															return (
																<tr key={index}>
																	<th className="border-b border-gray-200 align-middle font-light text-sm px-2 py-4 text-left capitalize">
																		{index + 1}
																	</th>
																	<th className="border-b border-gray-200 align-middle font-light text-sm px-2 py-4 text-left capitalize">
																		{(item.kegiatan || "-").toLowerCase()}
																	</th>
																	<th className="border-b border-gray-200 align-middle font-light text-sm px-2 py-4 text-left capitalize">
																		{item.tanggal || "-"}
																	</th>
																	<th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
																		{item.kementerian?.singkatan || "-"}
																	</th>
																	<th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
																		<div className="flex justify-evenly flex-col">
																			<button className="bg-warning/10 text-warning p-2 rounded-lg hover:bg-warning hover:text-white transition shadow-sm group mb-2"
																				onClick={(_e) => {
																					setDataUpdate(item);
																				}}
																			>
																				<Icon name="edit" size="xl" />
																			</button>
																			<button className="bg-danger/10 text-danger p-2 rounded-lg hover:bg-danger hover:text-white transition shadow-sm group"
																				onClick={(_e) => {
																					deleteKegiatan(item.id_kegiatan);
																				}}
																			>
																				<Icon name="delete" size="xl" />
																			</button>
																		</div>
																	</th>
																</tr>
															);
														}) : (
															<tr>
																<td
																	colSpan={5}
																	className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center"
																>
																	Tidak Ada Data
																</td>
															</tr>
														)
													) : (
														<tr>
															<td
																colSpan={6}
																className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-center animate-pulse"
															>
																Memuat Data...
															</td>
														</tr>
													)}
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* Modal for add user */}
					{showAddModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-text-heading/50 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-lg mx-auto my-6">
        <div className="border-0 rounded-2xl shadow-xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t-2xl">
            <h3 className="text-xl font-bold text-text-heading">Tambah Kegiatan Kementerian
						</h3>
            <button className="p-1 ml-auto bg-transparent border-0 text-text-muted float-right text-3xl leading-none font-semibold outline-none focus:outline-none hover:text-danger" onClick={() => closeModal()}>×</button>
          </div>
          <div className="relative p-6 flex-auto">
							<form
								onSubmit={(e) => {
									e.preventDefault();
									addKegiatan();
								}}
							>
								<div className="flex flex-wrap">
									<div className="w-full mb-3">
										<label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
											Kegiatan
										</label>
										<input
											className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
											type="text"
											placeholder="Tambah Kegiatan..."
											value={kegiatan}
											onChange={(e) => {
												setKegiatan(e.target.value);
											}}
											required
										/>
									</div>

									<div className="w-full mb-3">
										<label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
											Kementerian
										</label>
										<select
											className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
											onChange={(e) => {
												setKementerian(e.target.value);
											}}
											value={kementerian}
											required
										>
											<option value={0}>Pilih Kementerian</option>
											{allKementerian.length > 0 &&
												allKementerian.map((item, index) => {
													return (
														<option key={index} value={item.id_kementerian}>
															{item.singkatan}
														</option>
													);
												})}
										</select>
									</div>
									<div className="w-full mb-3">
										<label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
											Tanggal Kegiatan
										</label>
										<input
											className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
											type="date"
											onChange={(e) => {
												setTanggal(e.target.value);
											}}
											value={tanggal}
										></input>
									</div>
									<div className="w-full flex justify-between items-center">
										<button
											type="submit"
											className={
												"text-white bg-primary focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-30 disabled:pointer-events-none"
											}
											disabled={loading || !valid}
										>
											Submit
										</button>
										<p className="text-sm text-gray-700">{message}</p>
									</div>
								</div>
							</form>
						</div>
        </div>
      </div>
    </div>
  )}

					{/* Modal for edit user */}
					{showEditModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-text-heading/50 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-lg mx-auto my-6">
        <div className="border-0 rounded-2xl shadow-xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t-2xl">
            <h3 className="text-xl font-bold text-text-heading">closeModal()}>
							Ubah Kegiatan</h3>
            <button className="p-1 ml-auto bg-transparent border-0 text-text-muted float-right text-3xl leading-none font-semibold outline-none focus:outline-none hover:text-danger" onClick={() => closeModal()}>×</button>
          </div>
          <div className="relative p-6 flex-auto">
							<form
								onSubmit={(e) => {
									e.preventDefault();
									editKegiatan();
								}}
							>
								<div className="flex flex-wrap">
									<div className="w-full mb-3">
										<label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
											Kegiatan
										</label>
										<input
											className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
											type="text"
											placeholder="Masukkan NIM..."
											value={kegiatan}
											onChange={(e) => {
												setKegiatan(e.target.value);
											}}
											required
										/>
									</div>
									<div className="w-full mb-3">
										<label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
											Kementerian
										</label>
										<select
											className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
											value={kementerian}
											onChange={(e) => {
												setKementerian(e.target.value);
											}}
											required
										>
											<option value={0}>Pilih Kementerian</option>
											{allKementerian ? (
												allKementerian.map((item, index) => {
													return (
														<option key={index} value={item.id_kementerian}>
															{item.singkatan}
														</option>
													);
												})
											) : (
												<></>
											)}
										</select>
									</div>
									<div className="w-full mb-3">
										<label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
											Tanggal Kegiatan
										</label>
										<input
											className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
											type="date"
											onChange={(e) => {
												setTanggal(e.target.value);
											}}
											value={tanggal}
										></input>
									</div>
									<div className="w-full flex justify-between items-center">
										<button
											type="submit"
											className="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-30 disabled:pointer-events-none"
											disabled={loading || !valid}
										>
											Submit
										</button>
										<p className="text-sm text-gray-700">{message}</p>
									</div>
								</div>
							</form>
						</div>
        </div>
      </div>
    </div>
  )}
				</>
			)}
		</>
	);
};

export default Kegiatan;
